/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Material ExpandLess Icon component.
 */
export const MaterialExpandLessIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M4 15l1.867 1.867L12 10.733l6.133 6.134L20 15l-8-8-8 8z'
        fillRule='evenodd'
        clipRule='evenodd'
        fill={iconColor} />
    </svg>
  );
};

MaterialExpandLessIcon.defaultProps = {
  color : Color.grey2
};
